// extracted by mini-css-extract-plugin
module.exports = {"root":"ob_Os3jno","button":"ob_tNBTu0","pro":"ob_u4dFIZ"};